import cn from "classnames"

import { Steps as StepsAntd } from "antd"

import styles from "./Steps.module.scss"

import type { StepsProps } from "."

export const Steps = (props: StepsProps) => {
  const { className, theme, ...rest } = props

  return (
    <StepsAntd
      className={cn(className, { [styles.darkTheme]: theme === "dark" })}
      {...rest}
    />
  )
}
